import axios from 'axios';
import { CHECK_PROMOCODE } from './types';
import { API_URL } from './../constants';

export const applyPromocode = (code, ordertypeId) => dispatch => {
    axios
        .post(API_URL + 'promocode/check', {
            code: code,
            ordertypeId: ordertypeId
        })
        .then(res => {
            dispatch({
                type: CHECK_PROMOCODE,
                payload: res.data
            });
        }).catch(error => {
            // throw (error);
        });
}
